import React from 'react'

import Img from 'components/base/Img'
import Link from 'components/base/Link'
import PostTagsList from 'components/blocks/Blog/PostTagsList'

import { Props } from './types'

import {
  Wrap,
  Title,
  ThumbnailWrap,
} from './styles'

const PostExcerpt: React.FC<Props> = ({
  featured_image: featuredImage,
  slug,
  tags,
  title,
}): React.ReactElement => (
  <Wrap>
    <ThumbnailWrap>
      {featuredImage && (
        <div>
          <Link to={`/blog/posts/${slug}`}>
            <Img
              src={featuredImage.url}
              src2x={undefined}
              alt={featuredImage.alt}
            />
          </Link>
        </div>
      )}
    </ThumbnailWrap>
    <Title>
      <Link to={`/blog/posts/${slug}`}>{title}</Link>
    </Title>
    <PostTagsList tags={tags} />
  </Wrap>
)

export default PostExcerpt
